<template>
  <div>
    <Form :label-width="115" label-position="left">
      <Row :gutter="20" >
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Year')"><!-- 年度 -->
            <DatePicker type="year" v-model="formItem.year" :clearable="true" style="width:100%" @on-change="dateFormat"></DatePicker>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('BU')"><!-- 业务单元 -->
            <Select v-model="formItem.businessUnit" :clearable="true" placeholder="" filterable>
              <Option :value="item.code" v-for="item in businessUnitList" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Department')"><!-- 部门 -->
            <Select v-model="formItem.department" :clearable="true" placeholder="" filterable>
              <Option :value="item.code" v-for="item in departmentList" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Funciton')"><!-- 职能 -->
            <Select v-model="formItem.postFun" :clearable="true" placeholder="" filterable >
              <Option :value="item.code" v-for="item in funcationList" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Performance_Priorities_Crux')"><!-- 关键绩效指标 -->
            <Input v-model="formItem.performancePriorities" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Detailed_Description')"><!-- 详细描述 -->
            <Input v-model="formItem.details" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <Button @click="getData"><!-- 检 索 -->{{$t('Search')}}</Button>
        </Col>
      </Row>
    </Form>
    <FormTitle :titleText="$t('Performance_Priorities')"/><!-- 绩效重点 -->
    <PerformanceFocus ref="PerformanceFocus"></PerformanceFocus>
    <FormTitle v-show="formItem.year < 2025" :titleText="$t('STI_Self')" /><!-- STI个人目标 -->
    <STIComponent v-show="formItem.year < 2025" ref="STIComponent"></STIComponent>
    
  </div>
</template>
<script>
import axios from 'axios'
import PerformanceFocus from "./AchTargetSettingComponents/PerformanceFocus.vue"
import STIComponent from "./AchTargetSettingComponents/STIComponent.vue"
import DateUtil from "../../../util/DateUtil";
export default {
  components: { STIComponent,PerformanceFocus},
  data() {
    return {
      date: new DateUtil(),
      formItem: {year:""},
      positionList:[],
      departmentList:[],
      businessUnitList:[],
      funcationList:[],
      TargetType:[],
      list: [
          {
          value: "1",
          label: "1"
          }
      ],
      modalFormItem: {},
      editFormItem: {},
      
    };
  },
  computed:{
    lang(){
        return this.$store.getters.selectLangeData
    }
  },
  created(){
    this.formItem.year = JSON.parse(
                  window.sessionStorage.getItem("userInfo")
                ).year
    this.getListData()
  },
  methods: {
    dateFormat(value1){
      console.log(value1,"11111")
      this.formItem.year = value1
    },
    getListData(){
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
          if(res){
            this.positionList=res.positionList
            this.departmentList=res.departmentList
            this.businessUnitList=res.businessUnitList
            this.funcationList=res.functionList
            this.TargetType=res.TargetType
           
            this.$refs.PerformanceFocus.positionList=res.positionList
            this.$refs.PerformanceFocus.departmentList=res.departmentList
            this.$refs.PerformanceFocus.businessUnitList=res.businessUnitList
            this.$refs.PerformanceFocus.funcationList=res.functionList
            this.$refs.PerformanceFocus.TargetType=res.TargetType

            this.$refs.STIComponent.positionList=res.positionList
            this.$refs.STIComponent.departmentList=res.departmentList
            this.$refs.STIComponent.businessUnitList=res.businessUnitList
            this.$refs.STIComponent.funcationList=res.functionList
            this.$refs.STIComponent.TargetType=res.TargetType
          }
          this.getData()
      })
    },
    getData(){
      this.formItem.year=this.date.dateVal(this.formItem.year,"YYYY")
      this.formItem = this.formItem
      this.$refs.PerformanceFocus.formItem=this.formItem
      this.$refs.PerformanceFocus.getData()
      this.$refs.STIComponent.formItem=this.formItem
      this.$refs.STIComponent.getData()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchTargetSetting.vue